import React from 'react'
import { Route } from 'react-router-dom';
import AsyncComp from 'components/hocs/AsyncComponent'
const Login = AsyncComp(() => import('modules/auth/containers/Login').then(module => module.default))

const SafeRoute = props => (
  props.user && props.user.pk_company
    ?
    <Route {...props} />
    :
    <Route path={props.path} component={Login} />
)
export default SafeRoute



// WEBPACK FOOTER //
// ./src/components/SafeRoute.js